// extracted by mini-css-extract-plugin
export var fadeIn = "_ih-1";
export var modalContent = "_ih-3";
export var overlay = "_ih-0";
export var popoverContent = "_ih-2";
export var results = "_ih-5";
export var searchInputWrapper = "_ih-4";